import React, { useState } from "react";

//material ui imports
import {
  Grid,
  TextField,
  Typography,
  Divider,
  Button,
  Stack,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import SaveIcon from "@mui/icons-material/Save";
import AssignmentIcon from "@mui/icons-material/Assignment";
//project imports
import config from "../../../../config";

//third party imports
import * as Yup from "yup";
import { useFormik } from "formik";
import useAxiosAuth from "../../../../hooks/useAxiosAuth";
import { LoadingButton } from "@mui/lab";
import { useSelector } from "react-redux";
import { convertDateToLocalReverse } from "../../../../utils/date-operations";

const FollowupForm = (props) => {
  //Constanst
  const axiosAuth = useAxiosAuth();
  const { onSave, onCancel, selectedFollowup } = props;
  const { userId, userName, role, displayRole } = useSelector(
    (state) => state.userReducer
  );
  const theme = useTheme();

  //States
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      id: selectedFollowup.id,
      candidateId: selectedFollowup.candidateId,
      comments: selectedFollowup.comments,
      followUpDate: convertDateToLocalReverse(selectedFollowup.followUpDate),
      nextFollowUpDate: convertDateToLocalReverse(
        selectedFollowup?.nextFollowUpDate
      ),
      followUpBy: userId,
    },
    validationSchema: Yup.object({
      comments: Yup.string()
        .max(100, "Must be 100 characters or less")
        .required("Required"),
      followUpDate: Yup.date("must be valid date").required("Required"),
    }),
    onSubmit: (values) => {
      values.followUpBy = userId;
      setLoading(true);
      if (selectedFollowup.id === 0) {
        axiosAuth
          .post("/api/CandidateFollowUps", values)
          .then((response) => {
            if (response.status === 200) {
              onSave();
            } else {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      } else {
        axiosAuth
          .put("/api/CandidateFollowUps", values)
          .then((response) => {
            if (response.status === 200) {
              onSave();
            } else {
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
      }
    },
  });

  return (
    <>
      <Grid container>
        {selectedFollowup.id === 0 ? (
          <Stack direction="row" sx={{ marginX: "auto", alignItems: "center" }}>
            <AssignmentIcon />

            <Typography
              color={theme.palette.primary.dark}
              variant="h5"
              textAlign="center"
              sx={{ marginLeft: 2 }}
            >
              Add Followup
            </Typography>
          </Stack>
        ) : (
          <Stack direction="row" sx={{ marginX: "auto", alignItems: "center" }}>
            <AssignmentIcon />
            <Typography
              color={theme.palette.primary.dark}
              variant="h5"
              textAlign="center"
              sx={{ marginLeft: 2 }}
            >
              Edit Followup Details
            </Typography>
          </Stack>
        )}
      </Grid>
      <Divider sx={{ marginY: 2 }} />
      <Grid container spacing={2}>
        <Grid item xl={12} lg={12} md={12} sm={12}>
          <form onSubmit={formik.handleSubmit}>
            {/* <TextField
              name="candidateName"
              label="Candidate Name *"
              onChange={formik.handleChange}
              value={formik.values.candidateName}
              fullWidth
              error={
                formik.touched.candidateName &&
                Boolean(formik.errors.candidateName)
              }
              helperText={
                formik.touched.candidateName && formik.errors.candidateName
              }
              sx={{ marginBottom: 3 }}
            /> */}

            <TextField
              name="followUpDate"
              type="date"
              label="Followup Date"
              onChange={formik.handleChange}
              value={formik.values.followUpDate}
              fullWidth
              error={
                formik.touched.followUpDate &&
                Boolean(formik.errors.followUpDate)
              }
              helperText={
                formik.touched.followUpDate && formik.errors.followUpDate
              }
              sx={{ marginBottom: 2 }}
            />
            <TextField
              name="nextFollowUpDate"
              type="date"
              label="Next Followup Date"
              onChange={formik.handleChange}
              value={formik.values.nextFollowUpDate}
              fullWidth
              error={
                formik.touched.nextFollowUpDate &&
                Boolean(formik.errors.nextFollowUpDate)
              }
              helperText={
                formik.touched.nextFollowUpDate &&
                formik.errors.nextFollowUpDate
              }
              sx={{ marginBottom: 2 }}
            />
            <TextField
              name="comments"
              label="Comments"
              type="text"
              onChange={formik.handleChange}
              value={formik.values.comments}
              fullWidth
              multiline
              rows={3}
              error={formik.touched.comments && Boolean(formik.errors.comments)}
              helperText={formik.touched.comments && formik.errors.comments}
            />
            <Divider sx={{ my: 2 }} />
            <Grid>
              <LoadingButton
                variant="contained"
                type="submit"
                loading={loading}
                loadingPosition="end"
                endIcon={<SaveIcon />}
              >
                Submit
              </LoadingButton>
              <Button
                variant="outlined"
                onClick={onCancel}
                sx={{ marginLeft: 2 }}
              >
                Cancel
              </Button>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </>
  );
};

export default FollowupForm;
